/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('DuplicateFileName', [function() {
        return {
            get: function(originalName) {
                return originalName.replace(/( copy ?(\d+)?)?(\.[^\.]*)?$/, function(match, copy, number, extension) {
                    if (match) {
                        // filename.ext -> filename copy.ext -> filename copy 2.ext -> filename copy 3.ext

                        number = number ? parseInt(number) + 1 : 2;

                        return ' copy' + (copy ? (' ' + number) : '') + (extension || '');
                    } else {
                        // filename with no extension

                        return ' copy';
                    }
                });
            }
        }
    }]);
